import { User } from '../../types/auth.types';

export enum AuthActionTypes {
  // Request Actions
  LOGIN_USER = '@@auth/LOGIN_USER',
  SIGNUP_USER = '@@auth/SIGNUP_USER',
  FORGOT_PASSWORD = '@@auth/FORGOT_PASSWORD',
  FORGOT_PASSWORD_CHANGE = '@@auth/FORGOT_PASSWORD_CHANGE',
  LOGOUT_USER = '@@auth/LOGOUT_USER',
  RESET = '@@auth/RESET',

  // Success Actions
  LOGIN_SUCCESS = '@@auth/LOGIN_SUCCESS',
  SIGNUP_SUCCESS = '@@auth/SIGNUP_SUCCESS',
  FORGOT_PASSWORD_SUCCESS = '@@auth/FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_CHANGE_SUCCESS = '@@auth/FORGOT_PASSWORD_CHANGE_SUCCESS',
  LOGOUT_SUCCESS = '@@auth/LOGOUT_SUCCESS',

  // Error Actions
  LOGIN_ERROR = '@@auth/LOGIN_ERROR',
  SIGNUP_ERROR = '@@auth/SIGNUP_ERROR',
  FORGOT_PASSWORD_ERROR = '@@auth/FORGOT_PASSWORD_ERROR',
  FORGOT_PASSWORD_CHANGE_ERROR = '@@auth/FORGOT_PASSWORD_CHANGE_ERROR',
  LOGOUT_ERROR = '@@auth/LOGOUT_ERROR',
}

type BaseAction<T extends AuthActionTypes> = {
  type: T;
};

// Login Actions
export type LoginAction = BaseAction<AuthActionTypes.LOGIN_USER> & {
  payload: { username: string; password: string };
};
export type LoginSuccessAction = BaseAction<AuthActionTypes.LOGIN_SUCCESS> & {
  user: User;
};
export type LoginErrorAction = BaseAction<AuthActionTypes.LOGIN_ERROR> & {
  error: string;
};

// Signup Actions
export type SignupAction = BaseAction<AuthActionTypes.SIGNUP_USER> & {
  payload: { email: string; password: string; fullname: string };
};
export type SignupSuccessAction = BaseAction<AuthActionTypes.SIGNUP_SUCCESS>;
export type SignupErrorAction = BaseAction<AuthActionTypes.SIGNUP_ERROR> & {
  error: string;
};

// Forgot Password Actions
export type ForgotPasswordAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD> & {
  payload: { email: string };
};
export type ForgotPasswordSuccessAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD_SUCCESS>;
export type ForgotPasswordErrorAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD_ERROR> & {
  error: string;
};

// Password Reset Actions
export type ResetPasswordAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD_CHANGE> & {
  payload: { newPassword: string; token: string; id: string };
};
export type ResetPasswordSuccessAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD_CHANGE_SUCCESS>;
export type ResetPasswordErrorAction = BaseAction<AuthActionTypes.FORGOT_PASSWORD_CHANGE_ERROR> & {
  error: string;
};

// Logout Actions
export type LogoutAction = BaseAction<AuthActionTypes.LOGOUT_USER>;
export type LogoutSuccessAction = BaseAction<AuthActionTypes.LOGOUT_SUCCESS>;
export type LogoutErrorAction = BaseAction<AuthActionTypes.LOGOUT_ERROR> & {
  error: string;
};

// Reset Action
export type ResetAuthAction = BaseAction<AuthActionTypes.RESET>;

export type AuthAction =
  | LoginAction
  | LoginSuccessAction
  | LoginErrorAction
  | SignupAction
  | SignupSuccessAction
  | SignupErrorAction
  | ForgotPasswordAction
  | ForgotPasswordSuccessAction
  | ForgotPasswordErrorAction
  | ResetPasswordAction
  | ResetPasswordSuccessAction
  | ResetPasswordErrorAction
  | LogoutAction
  | LogoutSuccessAction
  | LogoutErrorAction
  | ResetAuthAction;
